// PORTUGUÊS

export default {
    values: {
        'Type to search': 'Digite para buscar',
        REMOVE: 'REMOVER',
        Creating: 'Criando',
        Create: 'Criar',
        Close: 'Fechar',
        'Confirm deletion': 'Confirmar deleção',
        'No, I do not': 'Não tenho certeza',
        of: 'de',
        items: 'itens',
        Default: 'Padrão',
        Ascending: 'Ascendente',
        Descending: 'Descendente',
        All: 'Tudo',
        Description: 'Descrição',
        Name: 'Nome',
        Save: 'Salvar',
        Showing: 'Mostrando',
        Search: 'Buscar',
        Settings: 'Configurações',
        'New Channel': 'Novo Canal',
        'Edit Channel': 'Editar Canal',
        'All Channels': 'Todos os Canais',
        'There are no channels yet': 'Ainda não há canais',
        'Real Time Channels': 'Canais Em Tempo Real',
        channels: 'canais',
        channel: 'canal',
        'Channel name': 'Nome do canal',
        Type: 'Tipo',
        'Type to search for name or ID': 'Digite para buscar por nome ou ID',
        Number: 'Número',
        'If you really want to delete the channel, type': 'Se realmente quer deletar o canal, digite',
        'Channel created successfully.': 'Canal criado com sucesso.',
        'An error occurred on creating channel.': 'Ocorreu um erro ao criar o novo canal.',
        'Other Channel with same Id already registered': 'Já existe outro canal com o mesmo ID cadastrado',
        'An error ocurred on listing channel types': 'Ocorreu um erro para receber os dados de tipos de canais',
        'Channel updated successfully.': 'Canal atualizado com sucesso.',
        'An error occurred on updating channel.': 'Ocorreu um erro ao tentar atualizar o canal.',
        'Are you sure you want remove the channel': 'Tem certeza que deseja remover esse canal',
        'Missing id': 'ID não encontrado',
        'channel deleted.': 'Canal deletado com sucesso.',
        'An error occurred on deleted channel.': 'Ocorreu um erro ao tentar deletar este canal.',
        'Source Type': 'Tipo de Fonte',
        'Source Setup': 'Configurar Fonte',
        'Mapped Channels': 'Canais Mapeados',
        'MAPPED CHANNELS': 'CANAIS MAPEADOS',
        'Select channel': 'Selecionar canal',
        'Delete channel': 'Excluir Canal',
        Select: 'Selecione',
        'Channel is being used on one more resources.': 'O canal está sendo usado em um ou mais recursos',
        'Add Channel': 'Adcionar Canal',
        'Channel Name': 'Nome do Canal',
        'THERE ARE NO CHANNELS ASSIGNED TO THIS RESOURCE.': 'NÃO HÁ CANAIS ASSOCIADOS A ESTE RECURSO.',
        'Edit Query': 'Editar Query'
    }
}
